module.exports = __webpack_public_path__ + "static/media/large-lite.7ea517c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vehicles/large-lite.png
// module id = 649
// module chunks = 27